<template>
   <van-popup class="functions-sheet-wrap" v-model="dialogData.isShow" round position="bottom">
    <van-cascader
      :value="defaultValue"
      :options="catagoryIdoptions"
      active-color="#3380FF"
      @close="dialogData.isShow = false"
      @finish="onFinish"/>
  </van-popup>
</template>

<script>
  import './index.scss'
  import { Cascader, Popup } from 'vant'
  import subRefreshList from '../refreshList'

  export default {
    components: {
      [Popup.name]: Popup,
      [Cascader.name]: Cascader,
      subRefreshList
    },
    model: {
      prop: 'defaultValue',
    },
    props: {
      dialogData: Object,
      defaultValue: [Number, String]
    },
    data() {
      return {
        catagoryIdoptions: []
      }
    },
    created() {
      let data = this.$local.getObject('locations') || [];
      let newData = this.filterData(data);
      let newArr = [];
      newData.forEach(item => {
        newArr.push(item);
      });
      this.catagoryIdoptions = newArr;
    },
    methods: {
      filterData(data, level = 1) {
        data.forEach((ele) => {
          ele.text = ele.name;
          ele.value = ele.code;
          if(this.dialogData.level <= level) {
            delete ele.children;
          } else if(ele.children && ele.children.length) {
            this.filterData(ele.children, level + 1);
          }
        })
        return data;
      },
      onFinish({ selectedOptions }) {
        this.dialogData.isShow = false;
        this.$emit('success', selectedOptions);
      }
    }
  }
</script>

